(function () {
  'use strict';
  var PX = 'dv';
  function T() { return window.Theme; }
  function words() { var el = document.getElementById(PX + '-ui-strings'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) { try { return T().money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function pic(src, w) {
    if (!src) return '<span class="' + PX + '-ui__ph" aria-hidden="true"></span>';
    var u = /^data:/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">';
  }
  function count(n, W) { return n + ' ' + (n === 1 ? (W.item_one || 'item') : (W.item_other || 'items')); }
  function cartUrl() { return (T() && T().routes && T().routes.cart) || '/cart'; }
  function checkoutUrl() { return (T() && T().routes && T().routes.checkout) || '/checkout'; }
  var lastAdded = null, lastFocus = null;
  function trap(box, e) {
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function start(fn) { if (window.Theme && window.Theme.events) fn(); else document.addEventListener('DOMContentLoaded', function () { if (window.Theme) fn(); }); }
  var CHECK = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var IC = {
    close: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>',
    plus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>'
  };
  var root = document.documentElement, STILL_KEY = 'dv-still';
  function still() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private window: the toggle still works for this visit */ } }
  function paused() { return root.classList.contains('dv-still'); }
  function syncPause() {
    var on = paused();
    [].slice.call(document.querySelectorAll('[data-dv-pause]')).forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  if (lsGet(STILL_KEY) === '1') root.classList.add('dv-still');
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-dv-pause]') : null; if (!b) return;
    var on = !paused(); root.classList.toggle('dv-still', on); lsSet(STILL_KEY, on ? '1' : '0'); syncPause();
    document.dispatchEvent(new CustomEvent('dv:motion', { detail: { still: on } }));
  });
  function anchorId(a) {
    var h = a.getAttribute('href') || '', i = h.lastIndexOf('#');
    if (i < 0 || i === h.length - 1) return '';
    var id = h.slice(i + 1), base = h.slice(0, i).replace(/^#/, '');
    if (!id || id.charAt(0) === '/') return '';
    if (base && base !== '/' && base !== location.pathname) return '';
    return id;
  }
  if (!customElements.get('dv-spy')) {
    customElements.define('dv-spy', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this._on = {};
        this._click = function (e) {
          if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          var a = e.target.closest ? e.target.closest('a[href]') : null; if (!a) return;
          var id = anchorId(a); if (!id) return;
          var t = document.getElementById(id); if (!t) return;
          e.preventDefault();
          t.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'start' });
          try { history.replaceState(null, '', '#' + id); } catch (er) { /* the page still scrolled */ }
          if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
          try { t.focus({ preventScroll: true }); } catch (er) { /* old browsers */ }
        };
        document.addEventListener('click', this._click);
        this._rs = function () { clearTimeout(self._rt); self._rt = setTimeout(function () { self.watch(); }, 200); };
        window.addEventListener('resize', this._rs);
        this.watch();
      }
      watch() {
        var self = this, els = [];
        if (this._io) { this._io.disconnect(); this._io = null; }
        this.links = [];
        [].slice.call(document.querySelectorAll('.dv-chip')).forEach(function (a) {
          var id = anchorId(a), el = id && document.getElementById(id);
          if (el) { self.links.push({ a: a, id: id, el: el }); if (els.indexOf(el) < 0) els.push(el); }
        });
        if (!els.length || !('IntersectionObserver' in window)) return;
        els.sort(function (a, b) { return (a.compareDocumentPosition(b) & 4) ? -1 : 1; });
        this._els = els;
        this._io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { self._on[en.target.id] = en.isIntersecting; });
          self.mark();
        }, { rootMargin: '-16px 0px -' + Math.round(window.innerHeight * 0.5) + 'px 0px', threshold: 0 });
        els.forEach(function (el) { self._io.observe(el); });
      }
      mark() {
        var cur = '', on = this._on;
        (this._els || []).forEach(function (el) { if (on[el.id]) cur = el.id; });
        this.links.forEach(function (l) {
          var is = l.id === cur;
          l.a.classList.toggle('is-current', is);
          if (is) l.a.setAttribute('aria-current', 'location'); else if (l.a.getAttribute('aria-current') === 'location') l.a.removeAttribute('aria-current');
        });
      }
      disconnectedCallback() {
        document.removeEventListener('click', this._click);
        window.removeEventListener('resize', this._rs);
        if (this._io) this._io.disconnect();
        clearTimeout(this._rt);
      }
    });
  }
  if (!customElements.get('dv-fx')) {
    customElements.define('dv-fx', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        syncPause();
        if (!('IntersectionObserver' in window)) return;
        this._io = new IntersectionObserver(function (es) { self.classList.toggle('is-off', !es[0].isIntersecting); }, { threshold: 0 });
        this._io.observe(this);
      }
      disconnectedCallback() { if (this._io) this._io.disconnect(); }
    });
  }
  if (!customElements.get('dv-gallery')) {
    customElements.define('dv-gallery', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.rail = this.querySelector('[data-dv-rail]');
        this.slides = [].slice.call(this.querySelectorAll('.dv-gal__slide'));
        this.dots = [].slice.call(this.querySelectorAll('[data-dv-dot]'));
        this.i = 0; this.raf = 0;
        if (!this.rail || this.slides.length < 2) { this.classList.add('is-single'); return; }
        this._scroll = function () { if (!self.raf) self.raf = requestAnimationFrame(function () { self.raf = 0; self.sync(); }); };
        this.rail.addEventListener('scroll', this._scroll, { passive: true });
        this._click = function (e) {
          var t = e.target; if (!t.closest) return;
          var d = t.closest('[data-dv-dot]');
          if (d) { self.go(Number(d.getAttribute('data-dv-dot')) - 1); return; }
          if (t.closest('[data-dv-prev]')) self.go(self.i - 1, true);
          else if (t.closest('[data-dv-next]')) self.go(self.i + 1, true);
        };
        this.addEventListener('click', this._click);
        this._key = function (e) {
          var k = e.key, n = self.slides.length;
          if (k === 'ArrowRight') self.go(self.i + 1, true);
          else if (k === 'ArrowLeft') self.go(self.i - 1, true);
          else if (k === 'Home') self.go(0);
          else if (k === 'End') self.go(n - 1);
          else return;
          e.preventDefault();
        };
        this.rail.addEventListener('keydown', this._key);
        this._rs = function () { self.go(self.i, false, true); };
        window.addEventListener('resize', this._rs);
        this.sync();
      }
      go(i, wrap, instant) {
        var n = this.slides.length;
        if (wrap) i = (i + n) % n;
        i = Math.max(0, Math.min(n - 1, i));
        var x = this.slides[i].offsetLeft;
        try { this.rail.scrollTo({ left: x, behavior: (still() || instant) ? 'auto' : 'smooth' }); } catch (e) { this.rail.scrollLeft = x; }
        this.i = i; this.mark();
      }
      sync() {
        var w = this.rail.clientWidth || 1, i = Math.round(this.rail.scrollLeft / w);
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        if (i !== this.i) { this.i = i; this.mark(); }
      }
      mark() {
        var i = this.i;
        this.dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }
      disconnectedCallback() {
        if (this.rail) { this.rail.removeEventListener('scroll', this._scroll); this.rail.removeEventListener('keydown', this._key); }
        window.removeEventListener('resize', this._rs);
        if (this.raf) cancelAnimationFrame(this.raf);
      }
    });
  }
  if (!customElements.get('dv-in')) {
    customElements.define('dv-in', class extends HTMLElement {
      connectedCallback() {
        var self = this, r = this.getBoundingClientRect();
        if (still() || !('IntersectionObserver' in window) || r.top < window.innerHeight * 0.9) return;   /* already on screen (or above): nothing to arm */
        this.setAttribute('data-armed', '');
        this._io = new IntersectionObserver(function (es) {
          var e = es[0];
          if (e.isIntersecting || e.boundingClientRect.top < 0) self.fire();   /* scrolled past without stopping: just settle */
        }, { threshold: 0.25, rootMargin: '0px 0px -6% 0px' });
        this._io.observe(this);
        this._t = setTimeout(function () { self.fire(); }, 6000);              /* never stay armed for ever (e.g. a tall block that never reaches 25%) */
      }
      fire() {
        if (this._io) { this._io.disconnect(); this._io = null; }
        clearTimeout(this._t);
        this.classList.add('is-in');
      }
      disconnectedCallback() { if (this._io) this._io.disconnect(); clearTimeout(this._t); }
    });
  }
  if (!customElements.get('dv-rail')) {
    customElements.define('dv-rail', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('[data-dv-rtrack]');
        this.cards = this.track ? [].slice.call(this.track.children) : [];
        this.prev = this.querySelector('[data-dv-rprev]'); this.next = this.querySelector('[data-dv-rnext]'); this.cur = this.querySelector('[data-dv-rcur]');
        if (!this.track || this.cards.length < 2) { this.classList.add('is-single'); return; }
        this.raf = 0;
        this._scroll = function () { if (!self.raf) self.raf = requestAnimationFrame(function () { self.raf = 0; self.sync(); }); };
        this.track.addEventListener('scroll', this._scroll, { passive: true });
        this._click = function (e) {
          var t = e.target; if (!t.closest) return;
          if (t.closest('[data-dv-rprev]')) self.step(-1); else if (t.closest('[data-dv-rnext]')) self.step(1);
        };
        this.addEventListener('click', this._click);
        this._key = function (e) { if (e.key === 'ArrowRight') { self.step(1); e.preventDefault(); } else if (e.key === 'ArrowLeft') { self.step(-1); e.preventDefault(); } };
        this.track.addEventListener('keydown', this._key);
        this._rs = function () { self.sync(); };
        window.addEventListener('resize', this._rs);
        this.sync();
      }
      index() {
        var x = this.track.scrollLeft, best = 0, d = Infinity;
        this.cards.forEach(function (c, i) { var k = Math.abs(c.offsetLeft - this.track.offsetLeft - x); if (k < d) { d = k; best = i; } }, this);
        return best;
      }
      step(dir) {
        var i = Math.max(0, Math.min(this.cards.length - 1, this.index() + dir)), c = this.cards[i];
        var x = c.offsetLeft - this.track.offsetLeft;
        try { this.track.scrollTo({ left: x, behavior: still() ? 'auto' : 'smooth' }); } catch (e) { this.track.scrollLeft = x; }
      }
      sync() {
        var i = this.index(), t = this.track, end = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
        if (end) i = this.cards.length - 1;
        if (this.cur) this.cur.textContent = String(i + 1);
        if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
        if (this.next) this.next.disabled = end;
      }
      disconnectedCallback() {
        if (this.track) { this.track.removeEventListener('scroll', this._scroll); this.track.removeEventListener('keydown', this._key); }
        window.removeEventListener('resize', this._rs);
        if (this.raf) cancelAnimationFrame(this.raf);
      }
    });
  }
  if (!customElements.get('dv-tabs')) {
    customElements.define('dv-tabs', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.tabs = [].slice.call(this.querySelectorAll('[role="tab"]'));
        this.panels = this.tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
        if (this.tabs.length < 2) return;
        this._click = function (e) { var t = e.target.closest ? e.target.closest('[role="tab"]') : null; if (t && self.tabs.indexOf(t) > -1) self.select(self.tabs.indexOf(t), false); };
        this._key = function (e) {
          var i = self.tabs.indexOf(document.activeElement), n = self.tabs.length, j;
          if (i < 0) return;
          if (e.key === 'ArrowRight') j = (i + 1) % n; else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n; else if (e.key === 'Home') j = 0; else if (e.key === 'End') j = n - 1; else return;
          e.preventDefault(); self.select(j, true);
        };
        this.addEventListener('click', this._click);
        this.addEventListener('keydown', this._key);
        var cur = 0;
        this.tabs.forEach(function (t, k) { if (t.getAttribute('aria-selected') === 'true') cur = k; });
        this.select(cur, false);
      }
      select(i, focus) {
        var self = this;
        this.tabs.forEach(function (t, k) {
          var on = k === i, p = self.panels[k];
          t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
          if (p) p.hidden = !on;
        });
        if (focus) { try { this.tabs[i].focus(); } catch (e) { /* old browsers */ } }
      }
      disconnectedCallback() { this.removeEventListener('click', this._click); this.removeEventListener('keydown', this._key); }
    });
  }
  function addBiz(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function shortDate(d) { try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return ''; } }
  if (!customElements.get('dv-delivery')) {
    customElements.define('dv-delivery', class extends HTMLElement {
      connectedCallback() {
        var lo = parseInt(this.getAttribute('data-min'), 10) || 7, hi = parseInt(this.getAttribute('data-max'), 10) || 10, now = new Date();
        var a = shortDate(addBiz(now, lo)), b = shortDate(addBiz(now, hi)), lead = this.querySelector('[data-dv-lead]'), win = this.querySelector('[data-dv-win]');
        if (!a || !b || !win) return;
        if (lead && lead.getAttribute('data-js')) lead.textContent = lead.getAttribute('data-js');
        win.textContent = a + ' – ' + b; win.hidden = false;
      }
    });
  }
  if (!customElements.get('dv-pill')) {
    customElements.define('dv-pill', class extends HTMLElement {
      connectedCallback() {
        var self = this, hero = document.getElementById(this.getAttribute('data-target') || 'top'), foot = document.querySelector('.dv-foot');
        this.items = [].slice.call(this.querySelectorAll('[data-for]'));
        this.bays = this.items.map(function (it) { return document.getElementById(it.getAttribute('data-for')); }).filter(Boolean);
        this.mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
        this.s = { hero: true, foot: false };
        this.cur = '';
        this.pick(this.getAttribute('data-cur') || (this.items[0] ? this.items[0].getAttribute('data-for') : ''));
        if (!hero || !('IntersectionObserver' in window)) return;
        this._mq = function () { self.apply(); };
        if (this.mq.addEventListener) this.mq.addEventListener('change', this._mq);
        this._io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.target === hero) self.s.hero = e.isIntersecting; else self.s.foot = e.isIntersecting; });
          self.apply();
        }, { threshold: 0 });
        this._io.observe(hero); if (foot) this._io.observe(foot);
        this._bio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) self.pick(e.target.id); });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        this.bays.forEach(function (b) { self._bio.observe(b); });
        this.apply();
      }
      pick(id) {
        if (!id || id === this.cur) return;
        this.cur = id; this.setAttribute('data-cur', id);
        this.items.forEach(function (it) { if (it.getAttribute('data-for') === id) it.removeAttribute('hidden'); else it.setAttribute('hidden', ''); });
      }
      apply() {
        var s = this.s, phone = !!this.mq.matches, on = phone && !s.hero && !s.foot;
        root.classList.toggle('dv-has-pill', phone);
        this.classList.toggle('is-in', on);
        if (on) { this.removeAttribute('aria-hidden'); this.removeAttribute('inert'); } else { this.setAttribute('aria-hidden', 'true'); this.setAttribute('inert', ''); }
      }
      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        if (this._bio) this._bio.disconnect();
        if (this.mq && this.mq.removeEventListener && this._mq) this.mq.removeEventListener('change', this._mq);
        root.classList.remove('dv-has-pill');
      }
    });
  }
  var el = null, busy = false;
  function build() {
    if (el && document.body.contains(el)) return el;
    var W = words();
    el = document.createElement('div'); el.className = PX + '-ui'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="' + PX + '-ui__scrim" data-ui-close></div>' +
      '<section class="' + PX + '-ui__sheet" role="dialog" aria-modal="true" aria-label="' + esc(W.title) + '" tabindex="-1">' +
        '<div class="' + PX + '-ui__card">' +
          '<div class="' + PX + '-ui__head"><div class="' + PX + '-ui__headline"><span class="' + PX + '-ui__ok" aria-hidden="true">' + CHECK + '</span>' +
            '<div class="' + PX + '-ui__titles"><p class="' + PX + '-ui__kicker">' + esc(W.slip || 'Receipt') + '</p>' +
            '<h2 class="' + PX + '-ui__title" data-ui-title>' + esc(W.title) + '</h2></div></div>' +
            '<button type="button" class="' + PX + '-ui__close" data-ui-close aria-label="' + esc(W.close) + '">' + IC.close + '</button></div>' +
          '<div class="' + PX + '-ui__body" aria-live="polite"></div><div class="' + PX + '-ui__foot"></div>' +
        '</div>' +
      '</section>';
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-ui-close]')) { close(); return; }
      var q = e.target.closest('[data-ui-qty]');
      if (q && !busy) {
        busy = true;
        T().cart.change(q.getAttribute('data-key'), Number(q.getAttribute('data-ui-qty'))).then(function () { busy = false; return render(false); }).catch(function () { busy = false; });
      }
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); return; } trap(el, e); });
    document.body.appendChild(el); return el;
  }
  function line(i, W, isNew) {
    var variant = i.variant_title && !/^default title$/i.test(i.variant_title) ? '<span class="' + PX + '-ui__var">' + esc(i.variant_title) + '</span>' : '';
    return '<div class="' + PX + '-ui__line' + (isNew ? ' is-new' : '') + '" data-key="' + esc(i.key) + '">' + pic(i.image, 72) +
      '<div><a class="' + PX + '-ui__name" href="' + esc(i.url) + '"' + (isNew ? ' data-new="' + esc(W.added_tag || 'Added') + '"' : '') + '>' + esc(i.product_title || i.title) + '</a>' + variant +
        '<div class="' + PX + '-ui__ctrl"><div class="' + PX + '-ui__qty" role="group" aria-label="' + esc(W.qty) + '">' +
          '<button type="button" data-ui-qty="' + (i.quantity - 1) + '" data-key="' + esc(i.key) + '" aria-label="' + esc(W.minus) + '">' + IC.minus + '</button>' +
          '<output>' + i.quantity + '</output>' +
          '<button type="button" data-ui-qty="' + (i.quantity + 1) + '" data-key="' + esc(i.key) + '" aria-label="' + esc(W.plus) + '">' + IC.plus + '</button></div>' +
          '<button type="button" class="' + PX + '-ui__rm" data-ui-qty="0" data-key="' + esc(i.key) + '">' + esc(W.remove) + '</button></div></div>' +
      '<span class="' + PX + '-ui__price">' + money(i.final_line_price) + '</span>' + giftRow(i) + '</div>';
  }
  function giftRow(i) {
    var t = document.getElementById('DvGiftTpl');
    if (!t || !i || t.getAttribute('data-handle') !== i.handle) return '';
    return '<div class="' + PX + '-ui__gift">' + t.innerHTML + '</div>';
  }
  function render(justAdded) {
    var W = words();
    return T().cart.get().then(function (c) {
      var body = el.querySelector('.' + PX + '-ui__body'), foot = el.querySelector('.' + PX + '-ui__foot');
      var newKey = justAdded && lastAdded && lastAdded.items && lastAdded.items[0] ? lastAdded.items[0].key : null;
      var title = el.querySelector('[data-ui-title]'), ok = el.querySelector('.' + PX + '-ui__ok');
      if (title) title.textContent = justAdded && c.items.length ? W.added : W.title;
      if (ok) ok.style.display = justAdded && c.items.length ? '' : 'none';
      body.innerHTML = c.items.length ? c.items.map(function (i) { return line(i, W, newKey && i.key === newKey); }).join('') : '<p class="' + PX + '-ui__empty">' + esc(W.empty) + '</p>';
      foot.innerHTML = '<div class="' + PX + '-ui__sum"><span class="' + PX + '-ui__sum-label">' + esc(W.subtotal) + ' · ' + count(c.item_count, W) + '</span><span class="' + PX + '-ui__dots" aria-hidden="true"></span>' +
          '<span class="' + PX + '-ui__sum-value">' + money(c.total_price) + '</span></div>' +
        '<p class="' + PX + '-ui__ship">' + esc(W.ship) + '</p>' +
        (c.items.length ? '<div class="' + PX + '-ui__buttons"><a class="' + PX + '-ui__btn" href="' + esc(checkoutUrl()) + '">' + esc(W.checkout) + '</a>' +
          '<a class="' + PX + '-ui__btn ' + PX + '-ui__btn--ghost" href="' + esc(cartUrl()) + '">' + esc(W.view_cart) + '</a></div>' : '') +
        '<button type="button" class="' + PX + '-ui__keep" data-ui-close>' + esc(W.keep) + '</button>';
    });
  }
  function openUi(justAdded) {
    build();
    if (!el.classList.contains('is-open')) lastFocus = document.activeElement;
    return render(justAdded).then(function () {
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); root.style.overflow = 'hidden';
      var b = el.querySelector('.' + PX + '-ui__close'); if (b) { try { b.focus({ preventScroll: true }); } catch (e) { b.focus(); } }
    }).catch(function () {});
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); root.style.overflow = '';
    if (lastFocus && lastFocus.focus && document.body.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* the page keeps its place */ } }
    lastAdded = null;
  }
  function afterAdd(after) {
    var ci = document.querySelector('boostly-cart-items');
    if (after === 'cart' && ci && typeof ci.renderSection === 'function') {
      T().cart.update(null, { sections: [ci.getAttribute('data-section-id')] })
        .then(function (r) { ci.renderSection(r.sections); })
        .catch(function () { window.location.href = cartUrl(); });
      return true;
    }
    if (after === 'cart') return false;
    openUi(true);
    return true;
  }
  function init() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.dv-top__cartlink') : null;
      if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (document.querySelector('boostly-cart-items')) return;
      e.preventDefault(); openUi(false);
    });
  }

  start(function () {
    T().events.on('cart:added', function (e) { lastAdded = e.detail || null; });
    T().afterAddHook = function (after) { return afterAdd(after); };
    if (typeof init === 'function') init();
  });
})();

/* phone buy bar (<PX-mbar>) + cart checkout bar visibility */
(function () {
  'use strict';
  var PX = 'dv';
  function fmt(c) { try { return window.Theme.money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  if (!customElements.get(PX + '-mbar')) customElements.define(PX + '-mbar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = document.querySelector('.' + PX + '-pdp .product-form__submit');
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (es) {
        var e = es[0]; self.show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.main);
      this.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mbar-add]') || self.main.disabled) return;
        self.main.click();
      });
      this.onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var p = self.querySelector('[data-mbar-price]'), b = self.querySelector('[data-mbar-add]');
        if (p) p.textContent = fmt(v.price);
        if (b) { b.disabled = !v.available; b.textContent = v.available ? self.dataset.add : self.dataset.sold; }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    show(on) { this.classList.toggle('is-in', on); document.documentElement.classList.toggle(PX + '-has-mbar', on); }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      document.documentElement.classList.remove(PX + '-has-mbar');
    }
  });
})();
